/**
 * CWE neutralization proof query and theorem helpers.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import { lookupTheorem } from "../proofViewShared.js";
import type { CweNeutralizationEntry } from "./types.js";
import theoremOrder from "./theorem-order.data.json" with { type: "json" };

export const THEOREM_ORDER = theoremOrder as readonly string[];

export function cweEntrySearchText(entry: CweNeutralizationEntry): string {
  return [
    String(entry.rank),
    String(entry.cwe_id),
    entry.name,
    entry.pattern,
    entry.owasp ?? "",
    ...entry.generators,
    ...entry.theorems,
  ]
    .join(" ")
    .toLowerCase();
}

export function entryMatches(entry: CweNeutralizationEntry, query: string): boolean {
  if (query === "") return true;
  return cweEntrySearchText(entry).includes(query);
}

export function theoremName(theoremCode: string): string {
  return lookupTheorem(theoremCode)?.name ?? theoremCode;
}
